import { render, staticRenderFns } from "./titleIndex.vue?vue&type=template&id=5c98d0d5&scoped=true&"
import script from "./titleIndex.vue?vue&type=script&lang=ts&"
export * from "./titleIndex.vue?vue&type=script&lang=ts&"
import style0 from "./titleIndex.vue?vue&type=style&index=0&id=5c98d0d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98d0d5",
  null
  
)

export default component.exports